import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

export type GetShipmentFactoryDependencies = {
  repository: ShipmentRepository
}

export function getShipmentFactory({ repository }: GetShipmentFactoryDependencies) {
  return function getShipmentByUUID(uuid: string, config?: { signal?: AbortSignal }) {
    return repository.getShipmentByUUID(uuid, config)
  }
}

export function getShipment(id: string, config?: { signal?: AbortSignal }) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const get = getShipmentFactory({ repository })

  return get(id, config)
}
